var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicNoteCrossedOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 3.25025V3.85986V5.21947V7.15276L4.85355 3.50631C4.65829 3.31105 4.34171 3.31105 4.14645 3.50631C3.95118 3.70157 3.95118 4.01815 4.14645 4.21342L8.5 8.56697V9.85986H7.5C6.39543 9.85986 5.5 10.7553 5.5 11.8599C5.5 12.9644 6.39543 13.8599 7.5 13.8599C8.60457 13.8599 9.5 12.9644 9.5 11.8599V10.8599V9.85986V9.56697L12.1464 12.2134C12.3417 12.4087 12.6583 12.4087 12.8536 12.2134C13.0488 12.0182 13.0488 11.7016 12.8536 11.5063L9.5 8.15276V5.60986L12.1213 4.95454C12.3439 4.8989 12.5 4.6989 12.5 4.46947V2.50025C12.5 2.17496 12.1943 1.93628 11.8787 2.01518L8.87873 2.76518C8.65615 2.82082 8.5 3.02081 8.5 3.25025Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNoteCrossedOut);
export default __webpack_public_path__ + "static/media/musicNoteCrossedOut.e371fced.svg";
export { ForwardRef as ReactComponent };